import { render, staticRenderFns } from "./LedgerGroupView.vue?vue&type=template&id=3f1b2f4b&scoped=true"
import script from "./LedgerGroupView.vue?vue&type=script&lang=js"
export * from "./LedgerGroupView.vue?vue&type=script&lang=js"
import style0 from "./LedgerGroupView.vue?vue&type=style&index=0&id=3f1b2f4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1b2f4b",
  null
  
)

export default component.exports